import { call, put } from "redux-saga/effects";
import { reviewApi } from "@services/api";
import { getTotalReviewUserActions } from "../slices";

function* getTotalReviewUserWorker({ payload }) {
  try {
    yield put(getTotalReviewUserActions.pending());
    const response = yield call(reviewApi.getTotalReviewUser, payload);
    yield put(getTotalReviewUserActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getTotalReviewUserActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getTotalReviewUserWorker };
